<html>

    <head>
        <link rel="stylesheet" type="text/css" href="https://cdn3.devexpress.com/jslib/23.1.3/css/dx-gantt.css" />   
    </head>

    <body class="dx-viewport">
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->  
        <dx-box
            direction="col"
            width="100%"
            [height]="formheight"
        >
            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx--> 
            <dxi-item
                [ratio]="3"
                class="rectangle"
            >
                <!----------------------------------------------------------------------------------------------->
                <dx-chart
                    #taskrangebarchart
                    id="taskrangebarchart"

                    [dataSource]="rangetodobarchart"

                    palette="Dark Moon"

                    [animation]="false"
                  
                    [title]="charttitle"

                    (onPointClick)="onPointClick($event)"
                    (onPointHoverChanged)="onPointHoverChanged($event)"
                    
                >
                    <!----------------------------------------------------------------------------------------------->
                    <dxo-margin
                        [top]="10"
                        [bottom]="10"
                        [left]="20"
                        [right]="20">
                    </dxo-margin>
                    <!----------------------------------------------------------------------------------------------->
                    <dxo-common-series-settings
                        type="rangeBar"

                        argumentField="taskdesc"
                        barOverlapGroup="taskdesc"

                    >

                    </dxo-common-series-settings>
                    <!----------------------------------------------------------------------------------------------->
                    <dxi-series 
                        name="Series1"

                        rangeValue1Field="startdate" 
                        rangeValue2Field="enddate"

                        [barWidth]="50"
                        
                    >

                        <dxo-label
                            [visible]="true"
                            position="outside"
                            [customizeText]="customizeText">
                        </dxo-label>

                    </dxi-series>
                    <!----------------------------------------------------------------------------------------------->
                    <dxi-series 
                        name="Series10"

                        rangeValue1Field="startdate" 
                        rangeValue2Field="progressenddate" 

                        color="green"

                        [barWidth]="30"
                       
                    >

                        <dxo-label
                            [visible]="false"
                        >
                        </dxo-label>

                    </dxi-series>
                    <!----------------------------------------------------------------------------------------------->
                    <dxo-value-axis
                      
                        [valueMarginsEnabled]="true"
                        [minValueMargin]="0.30"
                        [maxValueMargin]="0.30"
                    
                    >
                        <dxo-label format="dd-MMM-yy"></dxo-label>

                        <dxi-constant-line
                            [value]="eventdate"
                            color="#fc3535"
                            dashStyle="solid"
                            [extendAxis]="true"
                        
                            [width]="3"
                        >
                            <dxo-label 
                                [text]="eventdatename"
                                color="#fc3535"
                                verticalAlignment="top"
                                horizontalAlignment="right"
                                [visible]="true"
                            >
                            </dxo-label>

                        </dxi-constant-line>

                        <dxi-constant-line
                            [value]="currentdate"
                            color="#009933"
                            dashStyle="solid"
                            [extendAxis]="true"
                        
                            [width]="3"
                        >
                            <dxo-label 
                                [text]="currentdatetext"
                                color="#009933"
                                verticalAlignment="bottom"
                                [visible]="true"
                            >
                            </dxo-label>

                        </dxi-constant-line>

                    </dxo-value-axis>
                    <!----------------------------------------------------------------------------------------------->
                    <dxo-argument-axis
                        discreteAxisDivisionMode="crossLabels"
                    >
                
                        <dxo-label
                            [visible]="true"

                            position="outside"

                            displayMode="rotate"

                            [rotationAngle]="330"

                            alignment="center"

                            [customizeText]="customizeargumentText"
                        >

                        </dxo-label>
                      
                    </dxo-argument-axis>
                    <!----------------------------------------------------------------------------------------------->
                    <dxo-legend 
                        [visible]="false"
                        position="inside"
                        horizontalAlignment="right"
                        verticalAlignment="top"
                        orientation="vertical"
                    >
                    </dxo-legend>
                    <!----------------------------------------------------------------------------------------------->
                    <dxo-tooltip
                        [enabled]="charttooltip"

                        [cornerRadius]="35"
                        
                        
                        [customizeTooltip]="customizeTooltip"

                        [font]="{size: 18, weight:1000}"

                    >
                        
                    </dxo-tooltip>
                    <!----------------------------------------------------------------------------------------------->

                </dx-chart>

            </dxi-item>
            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx--> 
            <dxi-item
                [ratio]="0.05"
            >
            </dxi-item>
             <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx--> 
            <dxi-item
                [ratio]="1.5"
                class="rectangle"
            >
                <!----------------------------------------------------------------------------------------------->
                <dx-gantt 
                    #gridtodotask
                    id="gridtodotask"
     
                    [taskListWidth]="400"
           
                    height="90%"
                    width="100%"

                    scaleType="months"

                    [showRowLines]="true"

                    [startDateRange]="ganttstartdate"
                    [endDateRange]="ganttenddate"


                    (onOptionChanged)="onOptionChanged($event)"
                
                >
                    <!----------------------------------------------------------------------------------------------->
                    <dxo-tasks 
                        [dataSource]="subscriptiontodolistsingular"

                        KeyExpr="id"
                        ParenttaskidExpr="parenttaskid"

                        TitleExpr="title"
                        ParentIdExpr="parentId"
                        StartExpr="start"
                        EndExpr="end"
                    > 
                    </dxo-tasks>
                    <!----------------------------------------------------------------------------------------------->
                    <dxo-dependencies 
                        [dataSource]="subscriptiontodolistdependencylist"
                    >
                    </dxo-dependencies>
                    <!----------------------------------------------------------------------------------------------->
                    <dxo-filter-row 
                        [visible]="ganttfilterrow"
                    >
                    </dxo-filter-row>
                    <!----------------------------------------------------------------------------------------------->
                    <dxo-toolbar>
                        <dxi-item name="collapseAll"></dxi-item>
                        <dxi-item name="expandAll"></dxi-item>
                        <dxi-item name="separator"></dxi-item>
                        <dxi-item name="showDependencies"></dxi-item>
                        <dxi-item name="separator"></dxi-item>
                        <dxi-item name="zoomIn"></dxi-item>
                        <dxi-item name="zoomOut"></dxi-item>
                    </dxo-toolbar>
                    <!----------------------------------------------------------------------------------------------->
                    <dxi-column 
                        dataField="title" 
                        dataType="string"
                        caption="Task Description" 
                        allowEditing="false"

                        allowFiltering="true"
                        allowSearch="true"
                        allowEditing="false"
                     
                           
                        [filterOperations]="['=']"
                        selectedFilterOperation="="
                        [filterValue]="ganttfiltervalue"

                        [width]="200"

                        
                    >
                    </dxi-column>

                    <dxi-column 
                        dataField="start" 
                        dataType="date"
                        caption="Start Date" 
                        [format]="dateformat"
                        [width]="75"

                        allowEditing="false"
                        allowFiltering="false"
                    >
                    </dxi-column>

                    <dxi-column 
                        dataField="end" 
                        dataType="date"
                        caption="End Date" 
                        [format]="dateformat"
                        [width]="75"

                        allowEditing="false"
                        allowFiltering="false"
                    >

                       
                    </dxi-column>

                    <dxi-column 
                        dataField="id" 
                    
                        [width]="75"

                   
                    >

                    </dxi-column>

                    <!----------------------------------------------------------------------------------------------->
            
                </dx-gantt>


            </dxi-item>
            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx--> 
        </dx-box>
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx--> 
    </body>

</html>
